import Link from "next/link";
import React from "react";

interface Props {
  text: string;
  hrefTo: string;
}

export default function NavItem({ text, hrefTo }: Readonly<Props>) {
  return (
    <Link href={hrefTo} className="flex items-center">
      <span className="text-c-text hover:text-c-primary font-bold">{text}</span>
    </Link>
  );
}
